import { Pmp, PmpFormType, PmpStatus, PmpsWithPagination } from './Pmp';
import moment from 'moment';
import { Pageable } from 'ws/Pageable';
import { PmpWebService, RestfulPmpWebService } from 'ws/PmpWebService';

export interface PmpManager {
  getPmp: (pmpId: number) => Promise<Pmp>;
  getPmpList: (
    pageable: Pageable,
    search: string,
    status: number[]
  ) => Promise<PmpsWithPagination>;
  createPmp: (pmp: PmpFormType) => Promise<void>;
  updatePmp: (pmp: Pmp) => Promise<void>;
  updatePmpState(
    pmpIds: number[],
    state: 'activate' | 'deactivate'
  ): Promise<void>;
  getPmpsWithin(startTime: string, endTime: string): Promise<Pmp[]>;
  getPmpsByL1ObjectId: (l1ObjectId: number, status: number[]) => Promise<Pmp[]>;
}

export class DefaultPmpManager implements PmpManager {
  webService: PmpWebService;

  constructor(webService: PmpWebService = new RestfulPmpWebService()) {
    this.webService = webService;
  }

  getPmp(pmpId: number) {
    return this.webService.getPmp(pmpId);
  }

  getPmpList(pageable: Pageable, search = '', status: number[] = []) {
    return this.webService.getPmps(pageable, search, status);
  }

  async createPmp(pmp: PmpFormType) {
    return this.webService.createPmp(pmp);
  }

  updatePmp(pmp: Pmp) {
    return this.webService.updatePmp(pmp);
  }

  updatePmpState(pmpIds: number[], state: 'activate' | 'deactivate') {
    return this.webService.updatePmpState(pmpIds, state);
  }

  getPmpsWithin(startTime: string, endTime: string) {
    return this.webService.getPmpsWithin(startTime, endTime);
  }

  async getPmpsByL1ObjectId(l1ObjectId: number, status: number[] = []) {
    const pmpList = await this.webService.getPmpsByL1ObjectId(
      l1ObjectId,
      status
    );
    return pmpList.filter((pmp) => !pmp.campaignId);
  }

  isPmpEditable(pmp: Pmp): boolean {
    if ([PmpStatus.INACTIVE, PmpStatus.EXPIRED].includes(pmp.status)) {
      return false;
    }

    // pmp 最後設定時間為前一晚的 23:00
    const deliveryPreviousNight = moment(pmp.startTime)
      .startOf('day')
      .subtract(1, 'hour');
    if (moment().isAfter(deliveryPreviousNight)) {
      return false;
    }

    return true;
  }
}
